import React, { useEffect, useState } from 'react'
interface props{
    getLevel:any,
    onTimeUp: () => void;
}
function TimeLeft({getLevel,onTimeUp}:props) {
    const [timeLeft, setTimeLeft] = useState<number>(getLevel.itemQuestions == 100 ? 60 * 60 : 30 * 60);

    useEffect(() => {
    if (timeLeft <= 0){
      onTimeUp();
      return;
    } 
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer); // cleanup
}, [timeLeft]);
     const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };
  return (
    <div>  <h2>Time Remaining: {formatTime(timeLeft)}</h2>
          {timeLeft === 0 && <p>⏰ Time's up!</p>}</div>
  )
}

export default TimeLeft